import {
  SAVE_DATA_ASYNC,
  SAVE_DATA_ASYNC_LANGUAGE,
  CLEAR_DATA_ASYNC
} from "../actionType";

const saveToStore = (state, action) => {
  let updateState = state;
  updateState = { ...updateState, ...{ metaData: {...updateState.metaData,...action.data.metaData} } };
  return updateState;
};

const saveToStoreLanguage = (state, action) => {
  let updateState = state;
  updateState = { ...updateState, ...{ language: action.data.language } };
  return updateState;
};

const reducer = async (state, action) => {
  state = (localStorage.getItem("@storage"))
    ? JSON.parse(localStorage.getItem("@storage"))
    : {};
  switch (action.type) {
    case SAVE_DATA_ASYNC: {
      let updatedState = await saveToStore(state, action);
      localStorage.setItem("@storage", JSON.stringify(updatedState));
      return updatedState;
    }
    case SAVE_DATA_ASYNC_LANGUAGE: {
      let updatedState = await saveToStoreLanguage(state, action);
      localStorage.setItem("@storage", JSON.stringify(updatedState));
      return updatedState;
    }
    case CLEAR_DATA_ASYNC: {
      let updatedState = {metaData: null, token: null};
      localStorage.setItem("@storage", JSON.stringify({metaData: null, token: null}));
      return updatedState;
    }
    default:
      return state;
  }
};

export default reducer;
